import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { fetchUserProfile } from "../../features/user/userSlice";
import { getToken } from "../../utils/token";
import { setCredentials } from "../../features/auth/authSlice";

const StripeCallbackHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = getToken();
    if (!token) {
      console.warn("No token found after Stripe redirect");
      navigate("/login");
      return;
    }

    dispatch(fetchUserProfile())
      .unwrap()
      .then((userData) => {
        dispatch(
          setCredentials({
            token,
            user: userData,
            role: userData.role,
          })
        );
        navigate("/seller/profile"); // or dashboard
      })
      .catch((error) => {
        console.error("Failed to fetch profile after Stripe redirect:", error);
        navigate("/login");
      });
  }, [dispatch, navigate]);

  return <div>Finishing Stripe connection...</div>;
};

export default StripeCallbackHandler;
